module.exports = "https://static.wmbcdn.com/uniweb/images/3db01c4c8c4fd7a317c373952fc09509.svg";